




























import { Component, Vue } from "vue-property-decorator";
import { getContractAudits } from "@/services/contracts/contractService";
import { ContractActionType, ContractAudit } from "@/services/contracts/types";

@Component
export default class ContractHistoryModal extends Vue {
    contractAudits: ContractAudit[] = [] as ContractAudit[];
    selectedActionType: ContractActionType = ContractActionType.Recent; // by default show history without any filter
    actionTypeOptions: string[] = Object.values(ContractActionType);
    fields = [
        { key: "contractNumber", label: "Contract Nr." },
        { key: "action", label: "Sync Action" },
        { key: "timestamp", label: "Timestamp" },
        { key: "oldContract", label: "Old Contract" },
        { key: "newContract", label: "Updated / Created Contract" }
    ];

    open() {
        this.$bvModal.show("modal-historyContract");
        this.getFilteredContractAudits();
    }

    close() {
        this.$bvModal.hide("modal-historyContract");
    }

    getFilteredContractAudits() {
        getContractAudits(this.selectedActionType.toString()).then((response: any) => {
            this.contractAudits = response;
        });
    }
}
